import { SDialog } from "@avalara/skylab-sdk/react";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { unAssignBucketFromUser } from "../../../../app/bucketsSlice/bucketActions";
import { AppDispatch } from "../../../../app/types";
import type { RemoveSelectedUsersDialogProps, UnAssignBucketFromUserPayload, User } from "./types";

const RemoveSelectedUsersDialog = (props: RemoveSelectedUsersDialogProps) => {
    const {
        isRemoveDialogOpen,
        setIsRemoveDialogOpen,
        selectedUsers,
        setSelectedUsers,
        assignedUsers,
        bucketId,
    } = props;
    const dispatch = useDispatch<AppDispatch>();
    const isSingleUser = selectedUsers.size === 1;
    const singleUserName = isSingleUser
        ? assignedUsers.find((user: User) => selectedUsers.has(user.id))?.userName
        : undefined;
    const selectedCount = selectedUsers.size;
    const [isRemoving, setIsRemoving] = useState<boolean>(false);

    const handleCancel = (): void => {
        setIsRemoveDialogOpen(false);
    };

    const handleRemoveConfirm = useCallback((): void => {
        if (selectedUsers.size > 0) {
            setIsRemoving(true);
            const payload: UnAssignBucketFromUserPayload = {
                UserIds: Array.from(selectedUsers),
            };
            dispatch(unAssignBucketFromUser(payload, bucketId));
            setSelectedUsers(new Set<number>());
            setIsRemoveDialogOpen(false);
            setIsRemoving(false);
        }
    }, [selectedUsers, setSelectedUsers, setIsRemoveDialogOpen, dispatch, bucketId]);

    return (
        <SDialog
            open={isRemoveDialogOpen}
            onS-dismiss={handleCancel}
            id="remove-users-dialog"
            aria-modal="true">
            <div slot="header">
                <span className="pad-end-xl margin-end-xl">
                    {isSingleUser
                        ? "Remove this user from the bucket?"
                        : `Remove ${selectedCount} users from the bucket?`}
                </span>
            </div>

            <div slot="body">
                <span>
                    {isSingleUser
                        ? `Once removed, the user '${singleUserName}' will no longer have access to certificates in this bucket.`
                        : "Once removed, the selected users will no longer have access to certificates in this bucket."}
                </span>
            </div>

            <div slot="footer">
                <button
                    className="primary small"
                    onClick={handleRemoveConfirm}
                    disabled={isRemoving}>
                    Remove
                </button>
                <button className="secondary small" onClick={handleCancel} disabled={isRemoving}>
                    Cancel
                </button>
            </div>
        </SDialog>
    );
};

RemoveSelectedUsersDialog.displayName = "RemoveSelectedUsersDialog";
export default RemoveSelectedUsersDialog;
